import { FileViewerFileListStyled } from './styles/FileViewerFileListStyled'
import { useFileViewerContext } from '../../FileViewerContext'
import { Space } from '@ui/elements/Space'

export const FileViewerFileList = () => {
  const {
    files,
    selectFile,
    Components,
    selectedFile,
    getFileData,
    isFileSelected,
  } = useFileViewerContext()

  return (
    <FileViewerFileListStyled>
      <Space direction='horizontal' justify='center' align='center'>
        {files.map((file) => {
          return (
            <Components.FileListItem
              key={getFileData(file).id || getFileData(file).file}
              file={file}
              onClick={() => {
                selectFile(file)
              }}
              isActive={isFileSelected(file, selectedFile)}
            />
          )
        })}
      </Space>
    </FileViewerFileListStyled>
  )
}
